import { render, staticRenderFns } from "./PlacesAutocomplete.vue?vue&type=template&id=f0481496&"
import script from "./PlacesAutocomplete.vue?vue&type=script&lang=js&"
export * from "./PlacesAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports